// extracted by mini-css-extract-plugin
export default {"container":"GiftCard_container__s3MHR","upperSection":"GiftCard_upperSection__pdKEi","body":"GiftCard_body__BEK4Z"};